import {
  HeaderWrapper,
  HeaderTopRow,
  NavButtonSection,
  DesktopNav,
  HamburgerButton,
  MobileMenuItems,
  MobileMenuButton,
  Logo,
  HeaderButton,
  GeneratingSpinner,
} from './Header.styled';
import logo from '../../assets/evalLogo.png';
import { List } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { pdf } from '@react-pdf/renderer';
import { MoonLoader } from 'react-spinners';
import PDFDocument from '../PDF/pdf';
import { useResultPull } from '../../hooks/useResultPull';

const Header = ({ minimize, page }) => {
  const navigate = useNavigate();
  const validInputs = useSelector((state) => state.inputs.valid);
  const inputs = useSelector((state) => state.inputs.value);
  const { activeResult, data } = useResultPull({ enabled: false });
  const [generating, setGenerating] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const handleNavigate = (path) => {
    setMenuOpen(false);
    navigate(path);
  };

  const handleDownload = async () => {
    setGenerating(true);
    try {
      const blob = await pdf(
        <PDFDocument
          inputs={inputs}
          activeResult={activeResult}
          requestData={data}
        />,
      ).toBlob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      const now = new Date();
      const pad = (n) => String(n).padStart(2, '0');
      const dateStr = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}_${pad(now.getHours())}-${pad(now.getMinutes())}-${pad(now.getSeconds())}`;
      a.download = `workplace-charging-analysis-${dateStr}.pdf`;
      a.click();
      URL.revokeObjectURL(url);
    } finally {
      setGenerating(false);
    }
  };

  return (
    <HeaderWrapper $minimize={minimize} $menuOpen={menuOpen}>
      <HeaderTopRow>
        <NavButtonSection onClick={() => handleNavigate('/')}>
          <Logo
            src={logo}
            alt="Workplace Charging Logo"
            $minimize={minimize}
          ></Logo>
        </NavButtonSection>
        <NavButtonSection>
          <HamburgerButton onClick={() => setMenuOpen((o) => !o)}>
            <List size={30} color="white" />
          </HamburgerButton>
          <DesktopNav>
            {page == 'analysis' ? (
              <HeaderButton
                onClick={handleDownload}
                disabled={!activeResult || generating}
              >
                {generating ? (
                  <GeneratingSpinner>
                    <MoonLoader size={14} color="white" />
                    Generating...
                  </GeneratingSpinner>
                ) : (
                  'Download Report'
                )}
              </HeaderButton>
            ) : null}
            {page == 'methodology' ? (
              <>
                <HeaderButton onClick={() => handleNavigate('/input')}>
                  Inputs
                </HeaderButton>
                {validInputs && (
                  <HeaderButton onClick={() => handleNavigate('/analysis')}>
                    Results
                  </HeaderButton>
                )}
              </>
            ) : (
              <HeaderButton onClick={() => handleNavigate('/methodology')}>
                Methodology
              </HeaderButton>
            )}
          </DesktopNav>
        </NavButtonSection>
      </HeaderTopRow>
      <MobileMenuItems $open={menuOpen}>
        {page == 'analysis' ? (
          <MobileMenuButton
            onClick={handleDownload}
            disabled={!activeResult || generating}
          >
            {generating ? 'Generating...' : 'Download Report'}
          </MobileMenuButton>
        ) : null}
        {page == 'methodology' ? (
          <>
            <MobileMenuButton onClick={() => handleNavigate('/input')}>
              Inputs
            </MobileMenuButton>
            {validInputs && (
              <MobileMenuButton onClick={() => handleNavigate('/analysis')}>
                Results
              </MobileMenuButton>
            )}
          </>
        ) : (
          <MobileMenuButton onClick={() => handleNavigate('/methodology')}>
            Methodology
          </MobileMenuButton>
        )}
      </MobileMenuItems>
    </HeaderWrapper>
  );
};

export default Header;
